import React from "react";
import { ShieldCheck, Handshake, Award, Rocket } from "lucide-react";
import { images } from "../mock";

const points = [
  { icon: ShieldCheck, title: "Licensed & Trusted", desc: "Fully licensed mortgage lender operating across Texas, Louisiana and Florida." },
  { icon: Handshake, title: "Client-First Advisory", desc: "We explain every option so you make smart, informed decisions with total clarity." },
  { icon: Award, title: "Best-Rate Guarantee", desc: "We shop dozens of investors and banks to secure you the lowest available rate." },
  { icon: Rocket, title: "Fast Closings", desc: "Average 21-day close. Streamlined digital process from application to funding." }
];

export default function WhyUs() {
  return (
    <section id="about" className="section-pad relative" style={{ background: "#faf7f2" }}>
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
        <div className="reveal">
          <div className="relative rounded-3xl overflow-hidden shadow-3d-lg">
            <img src={images.handshake} alt="Mortgage advisor handshake" className="w-full h-[520px] object-cover" />
            <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, transparent 40%, rgba(3,5,36,0.55) 100%)" }} />
            <div className="absolute bottom-6 left-6 right-6 glass rounded-2xl p-5">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: "linear-gradient(135deg, #8DC63F, #6BA82E)" }}>
                  <Award size={22} style={{ color: "#070B5F" }} />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-slate-500">Since 2015</div>
                  <div className="font-serif text-lg font-semibold" style={{ color: "#070B5F" }}>Family-owned & operated</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="reveal">
          <span className="gold-bar mb-5" />
          <div className="text-xs uppercase tracking-[0.28em] font-semibold mt-3" style={{ color: "#6BA82E" }}>Why Top Choice Lending</div>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold mt-3 leading-tight" style={{ color: "#070B5F" }}>
            Mortgages made simple, human, and honest.
          </h2>
          <p className="mt-5 text-slate-600 text-lg leading-relaxed">
            As a licensed mortgage company, we know firsthand how overwhelming financing can feel.
            We take the confusion out of the process by explaining every option and putting you in
            control. Every client is our top priority — that's why we're your top choice.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-5">
            {points.map(({ icon: Icon, title, desc }) => (
              <div key={title} className="group p-5 rounded-2xl bg-white border border-slate-100 shadow-3d hover:-translate-y-1 transition-transform duration-300">
                <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-3" style={{ background: "rgba(141,198,63,0.12)" }}>
                  <Icon size={20} style={{ color: "#6BA82E" }} />
                </div>
                <div className="font-serif font-semibold text-lg" style={{ color: "#070B5F" }}>{title}</div>
                <div className="text-sm text-slate-600 mt-1.5 leading-relaxed">{desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
